export default __webpack_public_path__ + "static/library-26854eaa5e24a83c7907de666bfa8752.png";